import CartService from '../Service/CartService'
import ToastService from '../Service/ToastService'
import { trackAddToCart } from '../Tracking/Ecommerce'
import { getClosestElement } from '../Utility/Dom'

const BUTTON_SELECTOR = '[data-js="cart-add-button"]'
const OPTION_SELECTOR = '[data-js="cart-variant-option"]'

class CartAddButton {
  public init(): void {
    this.addEvents()
  }

  private addEvents(): void {
    document.addEventListener('click', (event: Event): void => {
      const button = getClosestElement(event.target as HTMLElement, 'cart-add-button')
      if (button === null) return

      void this.handleClick(button)
    })

    document.addEventListener('change', (event: Event): void => {
      const option = getClosestElement(event.target as HTMLElement, 'cart-variant-option')
      if (option === null) return

      this.findButtonForOption(option)?.removeAttribute('disabled')
    })
  }

  private findButtonForOption(option: HTMLElement): HTMLElement | null {
    let group = option.parentElement
    while (group !== null && group.querySelector(`:scope > ${BUTTON_SELECTOR}`) === null) {
      group = group.parentElement
    }

    return group?.querySelector<HTMLElement>(`:scope > ${BUTTON_SELECTOR}`) ?? null
  }

  private findSelectedVariantId(button: HTMLElement): string | undefined {
    const group = button.parentElement
    if (group === null) return undefined

    const selected = group.querySelector<HTMLInputElement>(`${OPTION_SELECTOR}:checked`)
    return selected?.value
  }

  private async handleClick(button: HTMLElement): Promise<void> {
    const { courseDateId, courseId } = button.dataset
    if (courseId === undefined) return

    const courseVariantId = this.findSelectedVariantId(button)

    button.setAttribute('disabled', 'disabled')
    try {
      const added = await CartService.addItem({ courseDateId, courseId, courseVariantId, quantity: 1 })
      if (added) {
        ToastService.showFromElement('cart-toast-added')
        trackAddToCart(CartService.getCart())
      }
    } finally {
      if (this.findSelectedVariantId(button) !== undefined || button.parentElement?.querySelector(OPTION_SELECTOR) === null) {
        button.removeAttribute('disabled')
      }
    }
  }
}

const cartAddButton = new CartAddButton()
cartAddButton.init()
